export default __webpack_public_path__ + "static/media/5N.67119f52.jpg";